export const ThumbService = {}

const maxThumbWidth = 3000

ThumbService.getThumbUrl = ({ width, preload, url }) => {
  if (width > maxThumbWidth) {
    throw Error(`The maximum width allowed is ${maxThumbWidth}px`)
  }

  try {
    const pathname = new URL(url).pathname
    const thumbUrl = `https://uos.unistroyrf.ru/thumbs/w${width}${pathname}`

    if (preload) {
      ThumbService.preloadImage(thumbUrl)
    }

    return thumbUrl
  } catch (err) {
    return url
  }
}

ThumbService.preloadImage = url => {
  const img = new Image()
  img.src = url
}
